/* @flow */
export default function defineUserPermissions(profile: ProfileT): PermissionsT {
  let isAdminRole, viewerAdmin, admin, superAdmin, orgAdmin, salesAffiliate, EPCMember;
  try {
    isAdminRole = profile.user_type > 0;
    viewerAdmin = profile.user_type === 1;
    admin = profile.user_type === 2;
    superAdmin = profile.user_type === 3;
    orgAdmin = profile.organization?.membership_type === 1;
    salesAffiliate = profile.organization?.business_type === 0;
    EPCMember = profile.organization?.business_type === 1;
  } catch (e) {
    isAdminRole = false;
    viewerAdmin = false;
    admin = false;
    superAdmin = false;
    orgAdmin = false;
    salesAffiliate = false;
    EPCMember = false;
  }

  return {
    isAdminRole,
    viewerAdmin,
    admin,
    superAdmin,
    orgAdmin,
    salesAffiliate,
    EPCMember,
  };
}
